import React, { useRef, useState } from 'react'
import { State } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { useConfirm } from 'src/hooks/useConfirm'
import { ConfirmDialog } from 'src/Components/Ui/ConfirmDialog'
import { generateSubject } from 'src/logic'
import { saveSimulation, sendUnifiedMail } from 'src/lib/api-client'
import { canvasToCompressedImage } from 'src/util/canvas'

type Images = {
  front: string
  rear: string
}

type Props = {
  state: State
  disabled: boolean
  email: string
  setSavedId: React.Dispatch<React.SetStateAction<string>>
  setIsSave: React.Dispatch<React.SetStateAction<boolean>>
}

export const SaveButton: React.FC<Props> = ({ state, disabled, email, setSavedId, setIsSave }) => {
  const { t, locale, isJa, isEn, isZhTw, isKo } = useLocale()
  const [isSaving, setIsSaving] = useState(false)
  const executeRef = useRef(false)
  const { isConfirmOpen, handleConfirmOpen, handleConfirmClose } = useConfirm()

  const captureImages = (): Images => ({
    front: canvasToCompressedImage('canvasFrontConfirm'),
    rear: canvasToCompressedImage('canvasBackConfirm')
  })

  const handleSave = async (state: State, newImages: Images) => {
    const brand = state.baseModel.brand
    handleConfirmClose()
    setIsSaving(true)
    if (executeRef.current) return
    try {
      executeRef.current = true
      const newState = { ...state, images: newImages }
      const response = await saveSimulation(newState)
      if (response.id === '999') return

      const subject = generateSubject(response.id, brand, isJa, isEn, isZhTw, isKo)
      const savedId = response.id
      setSavedId(savedId)

      // メール送信は非同期で実行（エラーが発生してもUIには影響しない）
      sendUnifiedMail({
        subject,
        savedId,
        imageUrls: newImages,
        email,
        locale
      }).catch((error) => {
        console.error('メール送信に失敗しました:', error)
      })

      setIsSaving(false)
      executeRef.current = false
    } catch (err) {
      executeRef.current = false
      console.error('シミュレーション保存エラー:', err)
    }
    handleConfirmClose()
    setIsSave(true)
  }
  return (
    <ConfirmDialog
      isConfirmOpen={isConfirmOpen}
      openButtonLabel={t.SAVE_BUTTON}
      dialogMessage={t.CONFIRM_SEND_EMAIL}
      color={'primary'}
      variant={'contained'}
      disabled={disabled || isSaving}
      isLoading={isSaving}
      handleOkButton={handleConfirmOpen}
      handleCancelButton={handleConfirmClose}
      handleExecuteButton={() => handleSave(state, captureImages())}
    />
  )
}
